// The WorkSafe family of products (by WorkSafeAgent LLC).
export const ECOSYSTEM = [
  {
    name: "WorkSafeAgent", domain: "worksafeagent.com", url: "https://worksafeagent.com", icon: "ShieldCheck",
    tag: { en: "The AI workplace safety platform — the family's flagship.", es: "La plataforma de seguridad laboral con IA — el buque insignia." },
  },
  {
    name: "WSafe.AI", domain: "wsafe.ai", url: "https://wsafe.ai", icon: "Shield",
    tag: { en: "AI-powered jobsite safety compliance.", es: "Cumplimiento de seguridad en obra con IA." },
  },
  {
    name: "HazardLoop", domain: "hazardloop.com", url: "https://hazardloop.com", icon: "RefreshCw",
    tag: { en: "Closed-loop hazard management — spot it, route it, verify it, close it.", es: "Gestión de peligros en ciclo cerrado — detéctalo, asígnalo, verifícalo, ciérralo." },
  },
  {
    name: "InductIQ", domain: "inductiq.ai", url: "https://inductiq.ai", icon: "ClipboardList",
    tag: { en: "AI incident reporting & OSHA 300/300A compliance.", es: "Reporte de incidentes con IA y cumplimiento OSHA 300/300A." },
  },
  {
    name: "SafeForm.ai", domain: "safeform.ai", url: "https://safeform.ai", icon: "PersonStanding",
    tag: { en: "Ergonomic video analysis to stop repetitive strain injuries.", es: "Análisis ergonómico en video para prevenir lesiones por esfuerzo repetitivo." },
  },
  {
    name: "WorkSafeStory", domain: "worksafestory.com", url: "https://worksafestory.com", icon: "MessagesSquare",
    tag: { en: "\u201CWhy I Work Safe\u201D — safety culture through storytelling.", es: "\u201CPor qu\u00e9 trabajo seguro\u201D — cultura de seguridad a trav\u00e9s de historias." },
  },
  {
    name: "EnviSafe.ai", domain: "envisafe.ai", url: null, current: true, icon: "Leaf",
    tag: { en: "Environmental compliance, closed-loop and AI-assisted.", es: "Cumplimiento ambiental, en ciclo cerrado y asistido por IA." },
  },
];
